export const CategoryAllListSuccess = 'CATEGORY_ALL_LIST_SUCCESS';
export const CategoryListSuccess = 'CATEGORY_LIST_SUCCESS';
export const EquipmentListSuccess = 'EQUIPMENT_LIST_SUCCESS';
export const EquipmentAllListSuccess = 'EQUIPMENT_ALL_LIST_SUCCESS';
export const EquipmentDetailsSuccess = 'EQUIPMENT_DETAILS_SUCCESS';
export const EquipmentGetFilterSuccess = 'EQUIPMENT_GET_FILTER_SUCCESS';

export function setAllCategoryListAction(data) {
  return {
    type: CategoryAllListSuccess,
    payload: data,
  };
}

export function setCategoryListAction(data) {
  return {
    type: CategoryListSuccess,
    payload: data,
  };
}

export function setEquipmentListAction(data) {
  return {
    type: EquipmentListSuccess,
    payload: data,
  };
}

export function setEquipmentAllListAction(data) {
  return {
    type: EquipmentAllListSuccess,
    payload: data,
  };
}

export function setEquipmentDetailsAction(data) {
  return {
    type: EquipmentDetailsSuccess,
    payload: data,
  };
}

export function setEquipmentFilterAction(data) {
  return {
    type: EquipmentGetFilterSuccess,
    payload: data,
  };
}
